import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { Invoice } from "../../../generated/graphql";
import moment from "moment";

const InvoiceHeader: React.FC<{ invoice: Invoice }> = ({ invoice }) => {
  return (
    <>
      <View style={styles.bannerContainer}>
        <Image style={styles.banner} src="/images/invoice-header.png" />
        <Text style={styles.invoiceNumber}>#{invoice?.invoiceNumber}</Text>
      </View>
      <View style={styles.container}>
        <View style={styles.colLeft}>
          <View>
            <Text style={[styles.lineItemLabel, { fontWeight: 400 }]}>
              Billed to:
            </Text>
            <Text style={[styles.lineItemValue, styles.customerName]}>
              {invoice?.customerName}
            </Text>
            <View style={styles.line} />
          </View>

          <Text style={[styles.refNo]}>Ref No: {invoice?.refNo ?? "-"}</Text>
        </View>
        <View style={styles.colRight}>
          <View style={styles.lineItem}>
            <Text style={styles.lineItemLabel}>Date:</Text>
            <Text style={styles.lineItemValue}>
              {moment(invoice?.invoiceDate).format("DD MMMM, YYYY")}
            </Text>
          </View>
          <View style={styles.lineItem}>
            <Text style={styles.lineItemLabel}>Booker:</Text>
            <Text style={styles.lineItemValue}>
              {invoice?.bookerName || "-"}
            </Text>
          </View>
          <View style={[styles.lineItem]}>
            <Text style={[styles.lineItemLabel]}>Payment By:</Text>
            <Text style={[styles.lineItemValue]}>{invoice?.paymentType}</Text>
          </View>
        </View>
      </View>
    </>
  );
};

// Create styles
const styles = StyleSheet.create({
  bannerContainer: {
    position: "absolute",
    top: 5,
    left: 0,
    right: 0,
    height: 90,
  },
  banner: {
    position: "absolute",
    top: 0,
    left: 15,
    right: 0,
    bottom: 0,
  },
  invoiceNumber: {
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "Poppins",
    position: "absolute",
    right: 46,
    bottom: 16,
    color: "#fe302f",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 4,
    paddingBottom: 4,
    marginTop: 75,
    fontFamily: "Poppins",
    fontSize: 8,
  },
  colLeft: {
    flex: 3,
  },
  colRight: {
    flex: 2,
  },
  lineItem: {
    display: "flex",
    flexDirection: "row",
  },
  lineItemLabel: {
    width: 150,
    fontWeight: 600,
  },
  lineItemDot: {
    textAlign: "center",
    width: 14,
  },
  lineItemValue: {
    width: 220,
    textAlign: "right",
  },
  refNo: {
    fontWeight: 600,
    marginTop: 2,
    marginBottom: 4,
  },
  customerName: {
    fontSize: 10,
    textTransform: "uppercase",
    color: "#1dd2ed",
    fontWeight: 600,
    textAlign: "left",
    lineHeight: 1.2,
  },
  line: {
    height: 1,
    backgroundColor: "#1dd2ed",
    marginTop: 8,
    marginBottom: 4,
    width: 100,
  },
});

export default InvoiceHeader;
